import $http from "./http";
import config from "./config";

export default {
  name: "btrip",
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  getTripRuleList(data) {
    return $http.post(this.getUrl(`/TripRule/List`), data);
  },
  getTripRuleDetails(RuleID) {
    return $http.get(this.getUrl(`/TripRule/Details/${RuleID}`));
  },
  saveTripRule(data) {
    return $http.post(this.getUrl(`/TripRule/Update`), data);
  },
  deleteTripRule(RuleID) {
    return $http.get(this.getUrl(`/TripRule/Delete/${RuleID}`));
  },
  getBtripTask(data) {
    return $http.post(this.getUrl(`/BtripTask/GetBtripTask`), data);
  },

  getBtripTextList(data) {
    return $http.post(this.getUrl(`/BtripText/list`), data);
  },
  getBtripTextDetails(TextID) {
    return $http.get(this.getUrl(`/BtripText/Details/${TextID}`));
  },
  getBtripTextUpdate(data) {
    return $http.post(this.getUrl(`/BtripText/Update`), data);
  },
  getBtripTexts(id) {
    return $http.get(this.getUrl(`/BtripText/BtripTexts/${id}`));
  },
  getBtripTextDelete(TextID) {
    return $http.get(this.getUrl(`/BtripText/Delete/${TextID}`));
  },
  getTripFlowList(data) {
    return $http.post(this.getUrl(`/TripFlow/List`), data);
  },
  getTripFlowDetail(id) {
    return $http.get(this.getUrl(`/TripFlow/Details/${id}`));
  },
  getTripFlowUpdate(data) {
    return $http.post(this.getUrl(`/TripFlow/TripFlowUpdate`), data);
  },
  getTripDelete(id) {
    return $http.get(this.getUrl(`/TripFlow/Delete/${id}`));
  },
  saveTripRejectReason(data) {
    return $http.post(this.getUrl("/BtripTask/Update"), data);
  },
  sendMsg(id) {
    return $http.get(this.getUrl("/BtripTask/sendmsg?UnionID=" + id));
  },
  getProjectList(data) {
    return $http.post(this.getUrl("/Project/List"), data);
  },
  saveProject(data) {
    return $http.post(this.getUrl("/Project/save"), data);
  },
  deleteProject(id) {
    return $http.get(this.getUrl("/Project/delete?id=" + id));
  },
  getList(data) {
    return $http.post(this.getUrl(`/BtripPolicy/List`), data);
  },
  getRulePosition(data) {
    return $http.post(this.getUrl(`/ApprovalRule/GetRulePosition`), data);
  },
  getQueryTravelRuleDetaile(id) {
    //查询差旅详情
    return $http.get(this.getUrl(`/OperatePolicy/QueryTravelRuleDetaile/${id}`));
  },
  getCreateTravelRule(data) {
    //创建修改差旅
    return $http.post(this.getUrl("/OperatePolicy/CreateTravelRule"), data);
  },
  getDeleteTravelRule(id) {
    //删除差旅
    return $http.get(this.getUrl(`/OperatePolicy/DeleteTravelRule/${id}`));
  },
  getApprovalRuleList(data) {
    //获取审批列表
    return $http.post(this.getUrl(`/OperatePolicy/QueryApprovalRuleList`), data);
  },
  ApprovalRuleList(data) {
    //获取审批列表
    return $http.post(this.getUrl(`/ApprovalRule/List`), data);
  },
  ApprovalDetail(id) {
    //获取审批规则详细
    return $http.get(this.getUrl(`/ApprovalRule/ApprovalDetail/${id}`));
  },
  ApprovalSave(data) {
    //审批规则保存
    return $http.post(this.getUrl(`/ApprovalRule/ApprovalSave`), data);
  },
  getDeleteApprovalRule(id) {
    //删除审批规则
    return $http.get(this.getUrl(`/OperatePolicy/DeleteApprovalRule/${id}`));
  },
  getCreateApprovalRule(data) {
    //创建/修改审批规则
    return $http.post(this.getUrl(`/OperatePolicy/CreateApprovalRule`), data);
  },
  getQueryApprovalRuleDetaile(id) {
    //查询审批规则详细
    return $http.get(this.getUrl(`/OperatePolicy/QueryApprovalRuleDetaile/${id}`));
  },
  getQueryApprovalPeople(id) {
    return $http.get(this.getUrl(`/OperatePolicy/QueryApprovalPeople/${id}`));
  },
  GetApprovalProgress(id) {
    return $http.get(this.getUrl(`/OperatePolicy/GetApprovalProgressByorderId/${id}`));
  },
  getServiceFeeInfoList(data) {
    //服务费列表
    return $http.post(this.getUrl(`/ServiceFeeInfo/List`), data);
  },
  getCreateServiceFee(data) {
    //添加修改服务费
    return $http.post(this.getUrl(`/ManagementServices/CreateServiceFee`), data);
  },
  getQueryServiceFeeDetaile(id) {
    //查询服务费详情
    return $http.get(this.getUrl(`/ManagementServices/QueryServiceFeeDetaile/${id}`));
  },
  getDeleteServiceFee(id) {
    //删除服务费
    return $http.get(this.getUrl(`/ManagementServices/DeleteServiceFee/${id}`));
  },
  getUpdateClientServiceFee(data) {
    //修改配置服务费
    return $http.post(this.getUrl(`/ClientServiceFee/UpdateClientServiceFee`), data);
  },
  getClientServiceFeeList(data) {
    //配置服务费列表
    return $http.post(this.getUrl(`/ClientServiceFee/List`), data);
  },
  Approver(id) {
    return $http.get(this.getUrl(`/OperatePolicy/IsEnableApproval/${id}`));
  },
  getTripRule(data) {
    return $http.post(this.getUrl(`/TripRule/GetTripRule`), data);
  },
  getCostCenter(id) {
    return $http.get(this.getUrl(`/BtripTask/GetCostCenter?TaskID=${id}`));
  },
  updatebtrip(data) {
    return $http.post(this.getUrl("/btriptask/updatebtrip"), data);
  },
  getApprovalOrderInfo(id) {
    return $http.get(this.getUrl(`/approval/ResolveOrder?id=${id}`));
  },
  approvalResolve(id) {
    return $http.get(this.getUrl(`/approval/resolve?id=${id}`));
  },
  approvalReject(id) {
    return $http.get(this.getUrl(`/approval/reject?id=${id}`));
  },
  saveTask(data) {
      return $http.post(this.getUrl(`Task/save`),data)
  },
  // 查询外出申请List
  getQueryApplicationList(data) {
    return $http.post(this.getUrl(`Task/list`),data)
  },
  // tripList出行
  QueryTripList(data) {
    return $http.post(this.getUrl(`trip/list`),data)
  },
  // 查询项目
  QueryProjectList(data) {
    return $http.post(this.getUrl(`project/list`), data)
  },
  getTripCityLabelList(data) {
    return $http.post(this.getUrl(`/TripCityLabel/List`),data);
  },
  saveCityLabel(data) {
    return $http.post(this.getUrl(`/TripCityLabel/Save`),data);
  },
  deleteCityLabel(id) {
    return $http.post(this.getUrl(`/TripCityLabel/Delete?id=${id}`));
  },
  getProjectRoleList(data) {
    return $http.post(this.getUrl("/ProjectRole/List"), data);
  },
  saveProjectRole(data) {
    return $http.post(this.getUrl("/ProjectRole/save"), data);
  },
  SearchUserProjects(data) {
    return $http.post(this.getUrl("/Project/SearchUserProjects"), data);
  },
};



// WEBPACK FOOTER //
// ./src/apis/btripApi.js